var $ = require('jquery');
var M = require("./vendors/materialize");

var Loading = function () {
    'use strict';
    
    this.progressModal = null;
    
    this.init = function () {
        $("#progressModal").modal({
            dismissible: false,
            opacity: 0.5,
            inDuration: 300,
            outDuration: 200,
            startingTop: '35%',
            endingTop: '35%',
            onOpenStart: function (modal, trigger) {
                $('#loading').show();
            },
            onCloseStart: function (modal, trigger) {
                $('#loading').hide();
            }

        });
        
        this.progressModal = M.Modal.getInstance(document.getElementById("progressModal"));
    };

    this.show = function () {
        if (this.progressModal == null)
            this.init();
        
        this.progressModal.open();
    }
    this.hide = function () {
        this.progressModal.close();
    }

    return this;
};

module.exports = Loading;
